// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"477":"6deebd3f","599":"f28cb571","933":"8311619c"}[chunkId] + ".chunk.js";
};